// Cross module mutation types

export const IS_AUTHENTICATED = 'IS_AUTHENTICATED'
